import styled from 'styled-components'
import { device } from 'utils/style'
import { ReactElement } from 'react'

export const TimelineWrapper = styled.div<{ maxHeight?: number }>`
  height: 100%;
  overflow-y: auto;
  padding-bottom: 24px;
`

export const TimelineGridWrapper = styled.div`
  display: grid;
  gap: 0 16px;
  grid-template-columns: min-content min-content 1fr;
`

export const TimelineEventWrapper = styled.div`
  align-items: stretch;
  display: flex;
  gap: 10px;

  @media ${device.tablet} {
    gap: 20px;
  }
`

export const TimelineDetailWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 24px;
`

export const TimelineDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 24px;
`

export const TimelineDecoratorWrapper = styled.div`
  position: relative;
  align-items: center;
  display: flex;
  flex-direction: column;
`

const EventLineWrapper = styled.div<{ color?: string; showLine?: boolean; hasIcon?: boolean }>`
  background: ${({ showLine }): string => (showLine ? '#5d59d7' : 'transparent')};
  height: 100%;
  margin: ${({ hasIcon }): string => (hasIcon ? '0px 22px' : '0px 6px')};
  width: ${({ hasIcon }): string => (hasIcon ? '2px' : '3px')};
  position: relative;
`

const Circle = styled.div<{ color?: string; hasIcon?: boolean }>`
  background: white;
  border: ${({ hasIcon }): string => (hasIcon ? '1px' : '4px')} solid ${({ color }): string => color ?? '#5d59d7'};
  border-radius: 50%;
  height: ${({ hasIcon }): string => (hasIcon ? '44px' : '8px')};
  width: ${({ hasIcon }): string => (hasIcon ? '44px' : '8px')};
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
`

interface IEventLineProps {
  color?: string
  showLine?: boolean
  icon?: ReactElement | null
}

export const EventLine = ({ color, showLine, icon }: IEventLineProps): ReactElement => (
  <EventLineWrapper color={color} showLine={showLine} hasIcon={!!icon}>
    {icon ? (
      <Circle color={color} hasIcon>
        {icon}
      </Circle>
    ) : (
      <Circle color={color} />
    )}
  </EventLineWrapper>
)
